import { SelectQueryBuilder } from 'typeorm';
import { Subscriber } from '@pushologies/database-service/db/entities/subscriber';
import { OperatorValue as Op, SegmentRule } from '../types';
import { Rule } from '.';

export class AppVersionRule extends Rule {
  constructor(private rule: SegmentRule<string[]>) {
    super();
  }

  updateQuery(query: SelectQueryBuilder<Subscriber>) {
    const [sql, params] = this.getQueryString();
    query.andWhere(sql, params);
  }

  private getQueryString(): [string, object] {
    const appVersionsParam = this.createParameterHash();
    switch (this.rule.operator) {
      case Op.in:
        return [`subscriber.app_version IN (:...${appVersionsParam})`, { [appVersionsParam]: this.rule.value }];
      case Op.notIn:
        return [`subscriber.app_version NOT IN (:...${appVersionsParam})`, { [appVersionsParam]: this.rule.value }];
      default:
        throw new Error(`operator "${this.rule.operator}" not supported`);
    }
  }
}
